<template>
  <div style="clear: both" class="change-type-editable-field">    
    <template v-if="readonly">      
      <v-text-field :label="$t(label)" variant="underlined" readonly :model-value="displayValue" dense
        density="comfortable"></v-text-field>
    </template>
    <template v-if="!readonly">
      <v-autocomplete
        :model-value="modelValue"
        variant="underlined"
        :label="$t(label)"
        :items="enabledItems"
        :filter="customFilter"
        item-title="type.value"
        item-value="type.key"
        v-on:update:model-value="updateValue"
        dense
        density="comfortable"
        ref="changeType"
        return-object
        persistent-placeholder
      ></v-autocomplete>
    </template>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import { ChangeTypes } from '@/common/types'
export default {
  name: 'ChangeTypeField',
  emits: ['change'],
  data() {
    return {
      label: this.$t('Change_Type')
    }
  },
  props: {
    items: {
      type: Array
    },
    value: {
      type: Object
    },
    modelValue: {
      type: Object
    },
    roles: {
      type: Array,
      default: null
    },
    previousFormStatus: {
      type: Object
    },
    forceReadonly: {
      type: Boolean,
      default: false
    },
    moc: {
      type: Object
    }
  },
  computed: {
    displayValue: function () {      
      if (this.readonly && this.modelValue.type !== undefined) {
        //return this.$t(this.value.type.key.toUpperCase())
        switch (this.modelValue.type.key) {
          case 'temporary':
            return ChangeTypes.properties[ChangeTypes.TEMPORARY].value
          case 'permanent':
            return ChangeTypes.properties[ChangeTypes.PERMANENT].value
        }
      }
      return null
    },
    readonly: function () {
      if (this.forceReadonly) {
        return true
      }
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (this.moc.history.some((e) => e.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value)) {
            return true
          }

          if (
            (this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value) &&
            (this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        default:
          return true
      }
      return true
    },
    enabledItems: function () {      
      console.log(`change type field this.$_ ${this.$_}`)
      var filteredList = this.$_.filter(this.items, function (obj) {
        return obj.enabled === true
      })
      return filteredList
    }
  },
  methods: {
    updateValue: function (value) {
      // this.$emit('input', value)
      this.$emit('update:modelValue', value)
      this.$emit('change', value)
    },
    valueChange: function (value) {
      this.$emit('change', value)
    },
    customFilter(item, queryText, itemText) {
      const textOne = itemText.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.toLowerCase().indexOf(searchText) === 0
    }
  }
}
</script>

<style>
.change-type-editable-field .v-select__selections {
  line-height: 15px;
}
</style>
